var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgFavoriteFilled = function SvgFavoriteFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 17.7917L8.79175 16.6917C4.50008 12.8 1.66675 10.2333 1.66675 7.08333C1.66675 4.51667 3.68341 2.5 6.25008 2.5C7.70008 2.5 9.09175 3.175 10.0001 4.24167C10.9084 3.175 12.3001 2.5 13.7501 2.5C16.3167 2.5 18.3334 4.51667 18.3334 7.08333C18.3334 10.2333 15.5001 12.8 11.2084 16.7L10.0001 17.7917Z",
    fill: "currentColor"
  })));
};
var Memo = /*#__PURE__*/memo(SvgFavoriteFilled);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/favorite-filled.c2fd3a8219fbf08b823462c274ea7ad1.svg";